import styled, { css } from 'styled-components';

import { DataWrapper } from 'libs/ui';

export const Content = styled(DataWrapper)`
  display: block;
  padding: ${(props) => {
    if (props.selectedTab === 'rfid' || props.selectedTab === 'epm' || props.selectedTab === 'plates' || props.selectedTab === 'subscription') {
      return '0';
    } else {
      return '25px 20px';
    }
  }};
`;

export const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const ClientData = styled.div`
  width: 590px;
  position: relative;
  form > div:last-child {
    margin-top: 20px;
  }
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      width: 100%;
      max-width: 720px;
    `}
`;

export const ProfileInfoData = styled.div`
  margin-left: 30px;
  color: #fff;
  font-size: 15px;
  flex-grow: 1;
  div {
    display: flex;
    align-items: center;
  }
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      color: var(--cp-text);
    `}
`;
